import React, { Component, Fragment } from 'react';
import { hideModal, showModal } from '../../../actions/modal.actions';
import { changeAccountStatus } from '../../../actions/accountDetailsActions/accountStatusChange.actions';
import { connect } from 'react-redux';
import {createLoadingSelector, getModalData} from '../../../selectors';
import {applyOnEnum, isEmpty} from "src/utils/helpers";
import {Formik} from "formik";
import * as Yup from 'yup';
import moment from "moment";
import DatePicker from "react-datepicker";

class AccountStatusChangeModal extends Component {
    state = {
        applyOnType: '',
        provisionImmediately: false,
        provisionImmediatelyEnabled: true
    };

    closeModal = () => {
        this.props.hideModal()
    }

    getFirstDayOfCurrentMonth() {
        const now = new Date();
        return new Date(now.getFullYear(), now.getMonth(), 1);
    }

    handleDateChange = (applyOnDate, setFieldValue) => {
        const { statusTransition } = this.props.modalProps;
        const attributes = statusTransition.workflowDefinitionAttributes;

        if (!applyOnDate) return; // Exit early if no date provided

        setFieldValue('applyOnDate', new Date(applyOnDate.getTime()));
        const selectedDate = moment(applyOnDate);
        const today = moment();

        if (!attributes.allowProvisionImmediately) {
            if (selectedDate.isSameOrBefore(today, 'day')) {
                this.setState({
                    provisionImmediately: true,
                    provisionImmediatelyEnabled: false
                });
            } else {
                this.setState({
                    provisionImmediately: false,
                    provisionImmediatelyEnabled: false
                });
            }
        } else if (selectedDate.isSameOrBefore(today, 'day')) {
            this.setState({
                provisionImmediately: true,
                provisionImmediatelyEnabled: false
            });
        } else {
            const defaultValue = attributes.provisionImmediatelyDefault !== undefined ? attributes.provisionImmediatelyDefault : false;
            this.setState({
                provisionImmediately: defaultValue,
                provisionImmediatelyEnabled: true
            });
        }
    }

    componentDidMount() {
        const {applyOnType} = this.state;
        const { statusTransition, currentValues } = this.props.modalProps;

        if (statusTransition && statusTransition.isLinesModal && currentValues) {
            const applyOnType = currentValues.applyOnType || Object.keys(applyOnEnum)[0];
            const attributes = statusTransition.workflowDefinitionAttributes || {};

            let provisionImmediately = currentValues.provisionImmediately !== undefined ? currentValues.provisionImmediately : false;
            let provisionImmediatelyEnabled = true;
            if (!attributes.allowProvisionImmediately) {
                const isOrderCompletionOrBillCycle = (applyOnType === Object.keys(applyOnEnum)[0] || applyOnType === Object.keys(applyOnEnum)[1]);
                if (isOrderCompletionOrBillCycle) {
                    provisionImmediately = true;
                } else {
                    provisionImmediately = false;
                }
                provisionImmediatelyEnabled = false;
            } else {
                const isOrderCompletionOrBillCycle = (applyOnType === Object.keys(applyOnEnum)[0] || applyOnType === Object.keys(applyOnEnum)[1]);

                if (isOrderCompletionOrBillCycle) {
                    provisionImmediately = true;
                    provisionImmediatelyEnabled = false;
                } else if (applyOnType === Object.keys(applyOnEnum)[3] && currentValues.applyOnDate) {
                    // Check if the selected date is today or in the past
                    const selectedDate = moment(currentValues.applyOnDate);
                    const today = moment();

                    if (selectedDate.isSameOrBefore(today, 'day')) {
                        provisionImmediately = true;
                        provisionImmediatelyEnabled = false;
                    } else {
                        provisionImmediately = currentValues.provisionImmediately !== undefined ? currentValues.provisionImmediately : (attributes.provisionImmediatelyDefault !== undefined ? attributes.provisionImmediatelyDefault : false);
                        provisionImmediatelyEnabled = true;
                    }
                } else {
                    provisionImmediately = currentValues.provisionImmediately !== undefined ? currentValues.provisionImmediately : (attributes.provisionImmediatelyDefault !== undefined ? attributes.provisionImmediatelyDefault : false);
                    provisionImmediatelyEnabled = true;
                }
            }

                this.setState({
                applyOnType: applyOnType,
                provisionImmediately: provisionImmediately,
                provisionImmediatelyEnabled: provisionImmediatelyEnabled
            });
        } else if (statusTransition && statusTransition.workflowDefinitionAttributes) {
            const attributes = statusTransition.workflowDefinitionAttributes || {};

            const allowedOptions = [
                attributes.allowOrderCompletion,
                attributes.allowStartOfBillCycle,
                attributes.allowNextBillCycle,
                attributes.allowSelectADate
            ].filter(Boolean).length;

            let defaultApplyOnType = Object.keys(applyOnEnum)[0];
            if (currentValues && currentValues.applyOnType) {
                defaultApplyOnType = currentValues.applyOnType;
            } else {
                if (allowedOptions === 1) {
                    if (attributes.allowOrderCompletion) {
                        defaultApplyOnType = Object.keys(applyOnEnum)[0];
                    } else if (attributes.allowStartOfBillCycle) {
                        defaultApplyOnType = Object.keys(applyOnEnum)[1];
                    } else if (attributes.allowNextBillCycle) {
                        defaultApplyOnType = Object.keys(applyOnEnum)[2];
                    } else if (attributes.allowSelectADate) {
                        defaultApplyOnType = Object.keys(applyOnEnum)[3];
                    }
                } else if (allowedOptions > 1) {
                    if (attributes.orderCompletionDefault && attributes.allowOrderCompletion) {
                        defaultApplyOnType = Object.keys(applyOnEnum)[0];
                    } else if (attributes.startOfBillCycleDefault && attributes.allowStartOfBillCycle) {
                        defaultApplyOnType = Object.keys(applyOnEnum)[1];
                    } else if (attributes.nextBillCycleDefault && attributes.allowNextBillCycle) {
                        defaultApplyOnType = Object.keys(applyOnEnum)[2];
                    } else if (attributes.selectADateDefault && attributes.allowSelectADate) {
                        defaultApplyOnType = Object.keys(applyOnEnum)[3];
                    } else {

                        if (attributes.allowOrderCompletion) {
                            defaultApplyOnType = Object.keys(applyOnEnum)[0];
                        } else if (attributes.allowStartOfBillCycle) {
                            defaultApplyOnType = Object.keys(applyOnEnum)[1];
                        } else if (attributes.allowNextBillCycle) {
                            defaultApplyOnType = Object.keys(applyOnEnum)[2];
                        } else if (attributes.allowSelectADate) {
                            defaultApplyOnType = Object.keys(applyOnEnum)[3];
                        }
                    }
                }
            }

            let provisionImmediately = false;
            let provisionImmediatelyEnabled = false;

            if (currentValues && currentValues.provisionImmediately !== undefined) {
                provisionImmediately = currentValues.provisionImmediately;
            } else {
                provisionImmediately = attributes.provisionImmediatelyDefault !== undefined ? attributes.provisionImmediatelyDefault : false;
            }

            if (!attributes.allowProvisionImmediately) {
                const isOrderCompletionOrBillCycle = (defaultApplyOnType === Object.keys(applyOnEnum)[0] || defaultApplyOnType === Object.keys(applyOnEnum)[1]);
                if (isOrderCompletionOrBillCycle) {
                    provisionImmediately = true;
                } else {
                    provisionImmediately = false;
                }
                provisionImmediatelyEnabled = false;
            } else {
                const isOrderCompletionOrBillCycle = (defaultApplyOnType === Object.keys(applyOnEnum)[0] || defaultApplyOnType === Object.keys(applyOnEnum)[1]);

                if (isOrderCompletionOrBillCycle) {
                    provisionImmediately = true;
                    provisionImmediatelyEnabled = false;
                } else if (defaultApplyOnType === Object.keys(applyOnEnum)[3] && currentValues && currentValues.applyOnDate) {
                    const selectedDate = moment(currentValues.applyOnDate);
                    const today = moment();

                    if (selectedDate.isSameOrBefore(today, 'day')) {
                        provisionImmediately = true;
                        provisionImmediatelyEnabled = false;
                    } else {
                        provisionImmediatelyEnabled = true;
                    }
                } else {
                    provisionImmediatelyEnabled = true;
                }
            }

            this.setState({
                applyOnType: defaultApplyOnType,
                provisionImmediately: provisionImmediately,
                provisionImmediatelyEnabled: provisionImmediatelyEnabled
            });

            setTimeout(() => {
                const currentApplyOnType = this.state.applyOnType;

                if (attributes.allowProvisionImmediately &&
                    (currentApplyOnType === Object.keys(applyOnEnum)[0] || currentApplyOnType === Object.keys(applyOnEnum)[1])) {
                    this.setState({
                        provisionImmediately: true,
                        provisionImmediatelyEnabled: false
                    });
                }
            }, 0);
        } else {
            this.setState({
                applyOnType: Object.keys(applyOnEnum)[0],
                provisionImmediately: true,
                provisionImmediatelyEnabled: false
            });
        }
    }

    onProvisionImmediatelyChangeHandler = (e) => {
        this.setState({provisionImmediately: e.target.checked});
    }

    onApplyOnTypeChangeClickHandler = (e) => {
        const { statusTransition } = this.props.modalProps;
        const attributes = statusTransition.workflowDefinitionAttributes;

        this.setState({applyOnType: e.target.value});

        if (!attributes.allowProvisionImmediately) {
        if ((e.target.value) && ((e.target.value == Object.keys(applyOnEnum)[0]) || (e.target.value == Object.keys(applyOnEnum)[1]))) {
                this.setState({
                    provisionImmediately: true,
                    provisionImmediatelyEnabled: false
                });
            } else {
                this.setState({
                    provisionImmediately: false,
                    provisionImmediatelyEnabled: false
                });
            }
        } else if ((e.target.value) && ((e.target.value == Object.keys(applyOnEnum)[0]) || (e.target.value == Object.keys(applyOnEnum)[1]))) {
            this.setState({
                provisionImmediately: true,
                provisionImmediatelyEnabled: false
            });
        } else if (e.target.value === Object.keys(applyOnEnum)[3]) {
            setTimeout(() => {
                if (this.currentFormValues && this.currentFormValues.applyOnDate) {
                    const selectedDate = moment(this.currentFormValues.applyOnDate);
                    const today = moment();

                    if (selectedDate.isSameOrBefore(today, 'day')) {
                        this.setState({
                            provisionImmediately: true,
                            provisionImmediatelyEnabled: false
                        });
                    } else {
                        const defaultValue = attributes.provisionImmediatelyDefault !== undefined ? attributes.provisionImmediatelyDefault : false;
                        this.setState({
                            provisionImmediately: defaultValue,
                            provisionImmediatelyEnabled: true
                        });
                    }
                } else {
                    const defaultValue = attributes.provisionImmediatelyDefault !== undefined ? attributes.provisionImmediatelyDefault : false;
                    this.setState({
                        provisionImmediately: defaultValue,
                        provisionImmediatelyEnabled: true
                    });
                }
            }, 0);
        } else {
            const defaultValue = attributes.provisionImmediatelyDefault !== undefined ? attributes.provisionImmediatelyDefault : false;
            this.setState({
                provisionImmediately: defaultValue,
                provisionImmediatelyEnabled: true
            });
        }
    }

    onAccountStatusChangeClickHandler = (values) => {
        const { accountInfo, statusTransition, onAccountStatusChange, onModalSubmit } = this.props.modalProps;

        if (statusTransition.isLinesModal && onModalSubmit) {
            onModalSubmit(this.state.applyOnType, values.applyOnDate, this.state.provisionImmediately, values.reasoncode);
            onAccountStatusChange();
            this.closeModal();
        } else {
        this.props.changeAccountStatus(accountInfo.id, statusTransition.toStatus, this.state.applyOnType, values.applyOnDate, this.state.provisionImmediately, values.reasoncode).then(response => {
            if (response.data && response.data.success) {
                onAccountStatusChange();
                this.closeModal();
            }
        })
        }
    }


    formSubmit = (values) => {
        this.onAccountStatusChangeClickHandler(values);
    };

    renderApplyOnText = (applyOn, applyDate, reasoncode) => {
        const { statusTransition } = this.props.modalProps;
        const provisionText = statusTransition.isNewOrderModal ? '' : (this.state.provisionImmediately ? ' with immediate provisioning' : ' without immediate provisioning');

        if(applyOn === Object.keys(applyOnEnum)[3]) {
            return `Are you sure you would like for your plan to be applied on ${moment(applyDate).format('YYYY-MM-DD')}${provisionText}?`
        } else {
            return `Are you sure you would like for your plan to be applied on ${applyOnEnum.valueOf()[applyOn]}${provisionText}?`
        }
    }

    handleOnSubmit = (values, { setSubmitting }) => {
        const { statusTransition } = this.props.modalProps;

        if (statusTransition.isLinesModal) {
            setSubmitting(false);
            this.formSubmit(values);
        } else if (statusTransition.workflowDefinitionAttributes) {
            this.props.showModal('GENERIC_MODAL', {
                title: "Plan Applied Date Confirmation",
                text: this.renderApplyOnText(this.state.applyOnType, values.applyOnDate, values.reasoncode),
                size: 'md',
                cancelText: "No",
                okText: "Yes",
                onOk: () => {
                    setSubmitting(false);
                    this.formSubmit(values);
                },
                onCancel: () => setSubmitting(false)
            });
        } else {
            setSubmitting(false);
            this.formSubmit(values);
        }
    }

    render() {
        const { statusTransition, currentValues } = this.props.modalProps;
        const { changeAccountStatusLoader } = this.props;
        const defaultReasonCodeId = currentValues && currentValues.reasoncodeId
            ? currentValues.reasoncodeId
            : (statusTransition &&
          statusTransition.workflowDefinitionReasoncodes &&
          statusTransition.workflowDefinitionReasoncodes.length > 0
            ? statusTransition.workflowDefinitionReasoncodes[0].reasoncode.id
                : null);

        const defaultApplyOnDate = currentValues && currentValues.applyOnDate && moment(currentValues.applyOnDate).isValid()
            ? moment(currentValues.applyOnDate).toDate()
            : null;

        return (
            <Fragment>
                <div className="modal" style={{ display: 'block' }} tabIndex="-1" role="dialog">
                    <Formik
                      initialValues={{
                          applyOnDate: defaultApplyOnDate,
                          reasoncode: defaultReasonCodeId,
                      }}
                      validationSchema={Yup.object().shape({
                          applyOnDate: Yup.date()
                              .nullable()
                              .test('date-required-when-select-date', 'Date is required', (value) => {
                                  if (this.state.applyOnType === Object.keys(applyOnEnum)[3]) {
                                      return value !== null && value !== undefined;
                                  }
                                  return true;
                              }),
                      })}
                      onSubmit={this.handleOnSubmit}
                      render={({ handleChange,
                                   handleSubmit,
                                   handleBlur,
                                   values,
                                   errors,
                                   touched,
                                   isSubmitting,
                                   setFieldValue}) => {
                                       this.currentFormValues = values;
                                       return (
                            <form className="cmv-form" onSubmit={handleSubmit}>
                                <div className="modal-dialog modal-md" role="document">
                                    <div className="modal-content">
                                        <div className="modal-header">
                                            <h5 className="modal-title">
                                                {statusTransition.name === 'APPLY ON' ? (
                                                    statusTransition.isNewOrderModal ? 'APPLY ON SETTINGS' : 'APPLY ON'
                                                ) : `${statusTransition.name} ACCOUNT`}
                                            </h5>
                                            <button type="button" className="close" onClick={() => this.closeModal()}>
                                                <span aria-hidden="true">&times;</span>
                                            </button>
                                        </div>
                                        <div className="modal-body form-horizontal">
                                            <div className="form-group">
                                                <div>
                                                    {statusTransition.name === 'APPLY ON' ? (
                                                        statusTransition.isNewOrderModal ? (
                                                            <span>You are about to set the apply on settings for this order.</span>
                                                        ) : statusTransition.isChangeFeature ? (
                                                            <span>You are about to change a feature or features for this service line.</span>
                                                        ) : (
                                                            <span>You are about to remove a service line or service lines from this account.</span>
                                                        )
                                                    ) : (
                                                    <span>You are about to update the account status from {statusTransition.fromStatus} to {statusTransition.toStatus}</span>
                                                    )}
                                                </div>
                                                &nbsp;
                                                {statusTransition && statusTransition.workflowDefinitionAttributes && (Array.isArray(statusTransition.workflowDefinitionAttributes) ? statusTransition.workflowDefinitionAttributes.length > 0 : Object.keys(statusTransition.workflowDefinitionAttributes).length > 0) && (statusTransition.isNewOrderModal || (statusTransition.workflowDefinitionAttributes.allowOrderCompletion || statusTransition.workflowDefinitionAttributes.allowStartOfBillCycle || statusTransition.workflowDefinitionAttributes.allowNextBillCycle || statusTransition.workflowDefinitionAttributes.allowSelectADate)) ? (
                                                    (() => {
                                                        const attributes = statusTransition.workflowDefinitionAttributes;
                                                        const allowedOptions = [
                                                            attributes.allowOrderCompletion,
                                                            attributes.allowStartOfBillCycle,
                                                            attributes.allowNextBillCycle,
                                                            attributes.allowSelectADate
                                                        ].filter(Boolean).length;
                                                        if (statusTransition.isNewOrderModal && (allowedOptions === 0 || allowedOptions === 1)) {
                                                            let staticTitle = "Order Completion";
                                                            let staticDescription = "Billing will take effect immediately, and provisioning will be triggered as soon as the request is submitted.";
                                                            if (allowedOptions === 1) {
                                                                if (attributes.allowOrderCompletion) {
                                                                    staticTitle = "Order Completion";
                                                                    staticDescription = "Billing will take effect immediately, and provisioning will be triggered as soon as the request is submitted.";
                                                                } else if (attributes.allowStartOfBillCycle) {
                                                                    staticTitle = "Start of Bill Cycle";
                                                                    staticDescription = "Billing will take effect as of the start of the current billing cycle, and provisioning will be triggered immediately.";
                                                                } else if (attributes.allowNextBillCycle) {
                                                                    staticTitle = "Next Bill Cycle";
                                                                    staticDescription = "Billing will take effect at the start of the next billing cycle (1 second before midnight UTC). No proration will be applied.";
                                                                } else if (attributes.allowSelectADate) {
                                                                    staticTitle = "Select a Date";
                                                                    staticDescription = "Billing will take effect on the selected date and time.";
                                                                }
                                                            }

                                                            return (
                                                                <div>
                                                                    <label>Apply On</label>
                                                                    <div className="mt-2">
                                                                        <div className="text-dark">
                                                                            {staticTitle}
                                                                        </div>
                                                                        <p className="text-muted text-xs mb-0 mt-1">
                                                                            {staticDescription}
                                                                        </p>
                                                                    </div>
                                                                    {staticTitle === "Select a Date" && (
                                                                        <div className="input-group mr-2 mt-2">
                                                                            <label>Date</label>
                                                                            <DatePicker
                                                                                className={"form-control datetimepicker-input" + (touched.applyOnDate && errors.applyOnDate ? " is-invalid" : "")}
                                                                                fieldName="applyOnDate"
                                                                                dateFormat="MM/dd/yyyy"
                                                                                placeholderText="MM/DD/YYYY"
                                                                                autoFocus={false}
                                                                                showTimeSelect={false}
                                                                                shouldCloseOnSelect={true}
                                                                                popperPlacement={'bottom'}
                                                                                selected={values.applyOnDate && moment(values.applyOnDate).isValid() ? moment(values.applyOnDate).toDate() : null}
                                                                                onChange={(applyOnDate) => this.handleDateChange(applyOnDate, setFieldValue)}
                                                                                minDate={this.getFirstDayOfCurrentMonth()}
                                                                            />
                                                                            {errors.applyOnDate &&
                                                                                touched.applyOnDate && (
                                                                                    <div className="invalid-feedback d-block">{errors.applyOnDate}</div>
                                                                                )}
                                                                        </div>
                                                                    )}
                                                                    {attributes.allowProvisionImmediately && !statusTransition.isNewOrderModal && (() => {
                                                                        const hasNextBillCycle = attributes.allowNextBillCycle;
                                                                        const hasSelectADate = attributes.allowSelectADate;
                                                                        if (hasNextBillCycle || hasSelectADate) {
                                                                            return (
                                                                                <div className="form-check checkbox-slider checkbox-slider--b-flat mt-2">
                                                                                    <label>
                                                                                        <input
                                                                                            type="checkbox"
                                                                                            name="provisionImmediately"
                                                                                            disabled={isSubmitting || !this.state.provisionImmediatelyEnabled}
                                                                                            onChange={this.onProvisionImmediatelyChangeHandler}
                                                                                            checked={this.state.provisionImmediately}
                                                                                        />
                                                                                        <span className="text-dark">
                                                                                            Provision Immediately
                                                                                            <i className="fas fa-info-circle text-primary ml-2"
                                                                                               title="Order Completion, Start of Bill Cycle, or Select a Date with current/past date will force Provision Immediately to true"
                                                                                               style={{cursor: 'pointer'}}></i>
                                                                                            <p className="text-muted text-xs mb-0">
                                                                                                Provisioning will be triggered immediately upon submitting the request.
                                                                                            </p>
                                                                                        </span>
                                                                                    </label>
                                                                                </div>
                                                                            );
                                                                        }

                                                                        return null;
                                                                    })()}
                                                                </div>
                                                            );
                                                        }
                                                        if (!statusTransition.isNewOrderModal && allowedOptions === 1) {
                                                            let staticTitle = "Order Completion";
                                                            let staticDescription = "Billing will take effect immediately, and provisioning will be triggered as soon as the request is submitted.";

                                                            if (attributes.allowStartOfBillCycle) {
                                                                staticTitle = "Start of Bill Cycle";
                                                                staticDescription = "Billing will take effect as of the start of the current billing cycle, and provisioning will be triggered immediately.";
                                                            } else if (attributes.allowNextBillCycle) {
                                                                staticTitle = "Next Bill Cycle";
                                                                staticDescription = "Billing will take effect at the start of the next billing cycle (1 second before midnight UTC). No proration will be applied.";
                                                            } else if (attributes.allowSelectADate) {
                                                                staticTitle = "Select a Date";
                                                                staticDescription = "Billing will take effect on the selected date and time.";
                                                            }

                                                            return (
                                                                <div>
                                                                    <label>Apply On</label>
                                                                    <div className="mt-2">
                                                                        <div className="text-dark">
                                                                            {staticTitle}
                                                                        </div>
                                                                        <p className="text-muted text-xs mb-0 mt-1">
                                                                            {staticDescription}
                                                                        </p>
                                                                    </div>
                                                                    {staticTitle === "Select a Date" && (
                                                                        <div className="input-group mr-2 mt-2">
                                                                            <label>Date</label>
                                                                            <DatePicker
                                                                                className={"form-control datetimepicker-input" + (touched.applyOnDate && errors.applyOnDate ? " is-invalid" : "")}
                                                                                fieldName="applyOnDate"
                                                                                dateFormat="MM/dd/yyyy"
                                                                                placeholderText="MM/DD/YYYY"
                                                                                autoFocus={false}
                                                                                showTimeSelect={false}
                                                                                shouldCloseOnSelect={true}
                                                                                popperPlacement={'bottom'}
                                                                                selected={values.applyOnDate && moment(values.applyOnDate).isValid() ? moment(values.applyOnDate).toDate() : null}
                                                                                onChange={(applyOnDate) => this.handleDateChange(applyOnDate, setFieldValue)}
                                                                                minDate={this.getFirstDayOfCurrentMonth()}
                                                                            />
                                                                            {errors.applyOnDate &&
                                                                                touched.applyOnDate && (
                                                                                    <div className="invalid-feedback d-block">{errors.applyOnDate}</div>
                                                                                )}
                                                                        </div>
                                                                    )}
                                                                    {attributes.allowProvisionImmediately && !statusTransition.isNewOrderModal && (() => {
                                                                        const hasNextBillCycle = attributes.allowNextBillCycle;
                                                                        const hasSelectADate = attributes.allowSelectADate;
                                                                        if (hasNextBillCycle || hasSelectADate) {
                                                                            return (
                                                                                <div className="form-check checkbox-slider checkbox-slider--b-flat mt-2">
                                                                                    <label>
                                                                                        <input
                                                                                            type="checkbox"
                                                                                            name="provisionImmediately"
                                                                                            disabled={isSubmitting || !this.state.provisionImmediatelyEnabled}
                                                                                            onChange={this.onProvisionImmediatelyChangeHandler}
                                                                                            checked={this.state.provisionImmediately}
                                                                                        />
                                                                                        <span className="text-dark">
                                                                                            Provision Immediately
                                                                                            <i className="fas fa-info-circle text-primary ml-2"
                                                                                               title="Order Completion, Start of Bill Cycle, or Select a Date with current/past date will force Provision Immediately to true"
                                                                                               style={{cursor: 'pointer'}}></i>
                                                                                            <p className="text-muted text-xs mb-0">
                                                                                                Provisioning will be triggered immediately upon submitting the request.
                                                                                            </p>
                                                                                        </span>
                                                                                    </label>
                                                                                </div>
                                                                            );
                                                                        }

                                                                        return null;
                                                                    })()}
                                                                </div>
                                                            );
                                                        }

                                                        return (
                                                    <div>
                                                        <label>Apply On</label>
                                                        {statusTransition.workflowDefinitionAttributes &&
                                                            statusTransition.workflowDefinitionAttributes.allowOrderCompletion && (
                                                                <div className="form-check checkbox-slider checkbox-slider--b-flat">
                                                                    <label>
                                                                        <input
                                                                            type="radio"
                                                                            name="applyOnType"
                                                                            disabled={isSubmitting}
                                                                            value={Object.keys(applyOnEnum)[0]}
                                                                            onChange={this.onApplyOnTypeChangeClickHandler}
                                                                            onBlur={handleBlur}
                                                                            checked={this.state.applyOnType == Object.keys(applyOnEnum)[0]}
                                                                        />
                                                                        <span>
																            Order Completion
																            <p className="text-muted text-xs mb-0">
																	            Billing will take effect immediately, and provisioning will be triggered as soon as the request is submitted.
																            </p>
															            </span>
                                                                    </label>
                                                                </div>
                                                            )}
                                                        {statusTransition.workflowDefinitionAttributes &&
                                                            statusTransition.workflowDefinitionAttributes.allowStartOfBillCycle && (
                                                                <div className="form-check checkbox-slider checkbox-slider--b-flat">
                                                                    <label>
                                                                        <input
                                                                            type="radio"
                                                                            name="applyOnType"
                                                                            disabled={isSubmitting}
                                                                            value={Object.keys(applyOnEnum)[1]}
                                                                            onChange={this.onApplyOnTypeChangeClickHandler}
                                                                            onBlur={handleBlur}
                                                                            checked={this.state.applyOnType == Object.keys(applyOnEnum)[1]}
                                                                        />
                                                                        <span>
																            Start of Bill Cycle
																            <p className="text-muted text-xs mb-0">
																	            Billing will take effect as of the start of the current billing cycle, and provisioning will be triggered immediately.
																            </p>
															            </span>
                                                                    </label>
                                                                </div>
                                                            )}
                                                        {statusTransition.workflowDefinitionAttributes &&
                                                            statusTransition.workflowDefinitionAttributes.allowNextBillCycle && (
                                                                <div className="form-check checkbox-slider checkbox-slider--b-flat">
                                                                    <label>
                                                                        <input
                                                                            type="radio"
                                                                            name="applyOnType"
                                                                            disabled={isSubmitting}
                                                                            value={Object.keys(applyOnEnum)[2]}
                                                                            onChange={this.onApplyOnTypeChangeClickHandler}
                                                                            onBlur={handleBlur}
                                                                            checked={this.state.applyOnType == Object.keys(applyOnEnum)[2]}
                                                                        />
                                                                        <span>
																            Next Bill Cycle
																            <p className="text-muted text-xs mb-0">
																	            Billing will take effect at the start of the next billing cycle (1 second before midnight UTC). No proration will be applied.
																            </p>
															            </span>
                                                                    </label>
                                                                </div>
                                                            )}
                                                        {statusTransition.workflowDefinitionAttributes &&
                                                            statusTransition.workflowDefinitionAttributes.allowSelectADate && (
                                                                <div className="form-check checkbox-slider checkbox-slider--b-flat">
                                                                    <label>
                                                                        <input
                                                                            type="radio"
                                                                            name="applyOnType"
                                                                            disabled={isSubmitting}
                                                                            value={Object.keys(applyOnEnum)[3]}
                                                                            onChange={this.onApplyOnTypeChangeClickHandler}
                                                                            onBlur={handleBlur}
                                                                            checked={this.state.applyOnType == Object.keys(applyOnEnum)[3]}
                                                                        />
                                                                        <span>
																            Select a Date
																            <p className="text-muted text-xs mb-0">
																	            Billing will take effect on the selected date and time.
																            </p>
															            </span>
                                                                    </label>
                                                                </div>
                                                            )}

                                                        &nbsp;
                                                        {this.state.applyOnType === Object.keys(applyOnEnum)[3] &&
                                                            <div className="input-group mr-2">
                                                                <label>Date</label>
                                                                <DatePicker
                                                                    className={"form-control datetimepicker-input" + (touched.applyOnDate && errors.applyOnDate ? " is-invalid" : "")}
                                                                    fieldName="applyOnDate"
                                                                    dateFormat="MM/dd/yyyy"
                                                                    placeholderText="MM/DD/YYYY"
                                                                    autoFocus={false}
                                                                    showTimeSelect={false}
                                                                    shouldCloseOnSelect={true}
                                                                    popperPlacement={'bottom'}
                                                                    selected={values.applyOnDate && moment(values.applyOnDate).isValid() ? moment(values.applyOnDate).toDate() : null}
                                                                    onChange={(applyOnDate) => this.handleDateChange(applyOnDate, setFieldValue)}
                                                                    minDate={this.getFirstDayOfCurrentMonth()}
                                                                />
                                                                {errors.applyOnDate &&
                                                                    touched.applyOnDate && (
                                                                        <div className="invalid-feedback d-block">{errors.applyOnDate}</div>
                                                                    )}
                                                            </div>
                                                        }
                                                        {errors.applyOnType &&
                                                            touched.applyOnType && (
                                                                <div className="invalid-feedback">{errors.applyOnType}</div>
                                                            )}
                                                        {statusTransition.workflowDefinitionAttributes &&
                                                            statusTransition.workflowDefinitionAttributes.allowProvisionImmediately && !statusTransition.isNewOrderModal && (() => {
                                                                const hasNextBillCycle = statusTransition.workflowDefinitionAttributes.allowNextBillCycle;
                                                                const hasSelectADate = statusTransition.workflowDefinitionAttributes.allowSelectADate;
                                                                if (hasNextBillCycle || hasSelectADate) {
                                                                    return (
                                                                <div className="form-check checkbox-slider checkbox-slider--b-flat">
                                                                    <label>
                                                                        <input
                                                                            type="checkbox"
                                                                            name="provisionImmediately"
                                                                            disabled={isSubmitting || !this.state.provisionImmediatelyEnabled}
                                                                            onChange={this.onProvisionImmediatelyChangeHandler}
                                                                            checked={this.state.provisionImmediately}
                                                                        />
                                                                                <span className="text-dark">
																            Provision Immediately
        																            <i className="fas fa-info-circle text-primary ml-2"
        																               title="Order Completion, Start of Bill Cycle, or Select a Date with current/past date will force Provision Immediately to true"
        																               style={{cursor: 'pointer'}}></i>
																            <p className="text-muted text-xs mb-0">
																	            Provisioning will be triggered immediately upon submitting the request.
																            </p>
															            </span>
                                                                    </label>
                                                                </div>
                                                                    );
                                                                }

                                                                return null;
                                                            })()}

                                                        </div>
                                                        );
                                                    })()
                                                ) : (
                                                    <div>
                                                        <label>Apply On</label>
                                                        <div className="mt-2">
                                                            <div className="text-dark">
                                                                {(() => {
                                                                    if (statusTransition.isNewOrderModal && currentValues && currentValues.applyOnType) {
                                                                        switch(currentValues.applyOnType) {
                                                                            case Object.keys(applyOnEnum)[0]:
                                                                                return "Order Completion";
                                                                            case Object.keys(applyOnEnum)[1]:
                                                                                return "Start of Bill Cycle";
                                                                            case Object.keys(applyOnEnum)[2]:
                                                                                return "Next Bill Cycle";
                                                                            case Object.keys(applyOnEnum)[3]:
                                                                                return "Select a Date";
                                                                            default:
                                                                                return "Order Completion";
                                                                        }
                                                                    }
                                                                    return "Order Completion";
                                                                })()}
                                                            </div>
                                                            <p className="text-muted text-xs mb-0 mt-1">
                                                                {(() => {
                                                                    if (statusTransition.isNewOrderModal && currentValues && currentValues.applyOnType) {
                                                                        switch(currentValues.applyOnType) {
                                                                            case Object.keys(applyOnEnum)[0]:
                                                                                return "Billing will take effect immediately, and provisioning will be triggered as soon as the request is submitted.";
                                                                            case Object.keys(applyOnEnum)[1]:
                                                                                return "Billing will take effect as of the start of the current billing cycle, and provisioning will be triggered immediately.";
                                                                            case Object.keys(applyOnEnum)[2]:
                                                                                return "Billing will take effect at the start of the next billing cycle (1 second before midnight UTC). No proration will be applied.";
                                                                            case Object.keys(applyOnEnum)[3]:
                                                                                return "Billing will take effect on the selected date and time.";
                                                                            default:
                                                                                return "Billing will take effect immediately, and provisioning will be triggered as soon as the request is submitted.";
                                                                        }
                                                                    }
                                                                    return "Billing will take effect immediately, and provisioning will be triggered as soon as the request is submitted.";
                                                                })()}
                                                            </p>
                                                        </div>
                                                        {statusTransition.isNewOrderModal && currentValues && currentValues.applyOnType === Object.keys(applyOnEnum)[3] && (
                                                            <div className="input-group mr-2 mt-2">
                                                                <label>Date</label>
                                                                <DatePicker
                                                                    className={"form-control datetimepicker-input" + (touched.applyOnDate && errors.applyOnDate ? " is-invalid" : "")}
                                                                    fieldName="applyOnDate"
                                                                    dateFormat="MM/dd/yyyy"
                                                                    placeholderText="MM/DD/YYYY"
                                                                    autoFocus={false}
                                                                    showTimeSelect={false}
                                                                    shouldCloseOnSelect={true}
                                                                    popperPlacement={'bottom'}
                                                                    selected={values.applyOnDate && moment(values.applyOnDate).isValid() ? moment(values.applyOnDate).toDate() : null}
                                                                    onChange={(applyOnDate) => this.handleDateChange(applyOnDate, setFieldValue)}
                                                                    minDate={this.getFirstDayOfCurrentMonth()}
                                                                />
                                                                {errors.applyOnDate &&
                                                                    touched.applyOnDate && (
                                                                        <div className="invalid-feedback d-block">{errors.applyOnDate}</div>
                                                                    )}
                                                                </div>
                                                            )}
                                                    </div>
                                                    )}
                                                <div>
                                                    <label>Reason</label>
                                                    <select
                                                        className={
                                                            errors.reasoncode && touched.reasoncode ? (
                                                                'form-control is-invalid'
                                                            ) : (
                                                                'form-control customer-notes-cat'
                                                            )
                                                        }
                                                        value={values.reasoncode || ""}
                                                        onChange={(e) => {
                                                            const value = e.target.value;
                                                            const reasoncodeId = value ? parseInt(value, 10) : null;
                                                            setFieldValue('reasoncode', reasoncodeId);
                                                        }}
                                                        onBlur={handleBlur}
                                                        name="reasoncode"
                                                        disabled={!statusTransition.workflowDefinitionReasoncodes || statusTransition.workflowDefinitionReasoncodes.length === 0}
                                                        title={!statusTransition.workflowDefinitionReasoncodes || statusTransition.workflowDefinitionReasoncodes.length === 0 ? "No Reason Codes Loaded" : ""}
                                                    >
                                                        {(!statusTransition.workflowDefinitionReasoncodes || statusTransition.workflowDefinitionReasoncodes.length === 0) && (
                                                            <option value="">No Reason Codes Loaded</option>
                                                        )}
                                                        {statusTransition.workflowDefinitionReasoncodes &&
                                                            statusTransition.workflowDefinitionReasoncodes.map((workflowReasoncode) => (
                                                            <option key={workflowReasoncode.reasoncode.id} value={workflowReasoncode.reasoncode.id}>
                                                                {workflowReasoncode.reasoncode.description}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="modal-footer">
                                            <button disabled={isSubmitting} onClick={() => this.closeModal()}
                                                    className="btn">
                                                CANCEL
                                            </button>
                                            <button
                                                type="submit"
                                                disabled={isSubmitting}
                                                className="btn btn-primary">
                                                CONTINUE
                                                {changeAccountStatusLoader &&
                                                  <i className="fas fa-fw fa-spin fa-spinner"
                                                     style={{ marginLeft: "5px" }} />}
                                            </button>

                                        </div>
                                    </div>
                                </div>
                            </form>
                                       );
                                   }}
                    />
                </div>
                <div className="modal-backdrop show" tabIndex="1" />
            </Fragment>
        )
    }

}

const changeAccountStatusLoaderSelector = createLoadingSelector(['CHANGE_ACCOUNT_STATUS']);

const mapStateToProps = (state) => {
    const modalProps = getModalData(state).modalProps;
    const changeAccountStatusLoader = changeAccountStatusLoaderSelector(state);
    return {
        modalProps,
        changeAccountStatusLoader
    }
};

const mapDispatchToProps = {
    changeAccountStatus,
    hideModal,
    showModal,
};

export default connect(mapStateToProps, mapDispatchToProps)(AccountStatusChangeModal);
